import Vue from 'vue';
import * as filters from './index';

export function initFilters() {
  Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
  });
}
